/**
 * @desc - 複数の画像を表示(商品写真)
 * @link - http://klutche.org/archives/460/
 */
$(function(){
  $("img#changePhoto1").click(function(){
    var ImgSrc = $(this).attr("src");
    var ImgAlt = $(this).attr("alt");
    $("img#mainPhoto1").attr({src:ImgSrc,alt:ImgAlt});
    $("a#mainPhoto1").attr({href:ImgSrc});
    $("img#mainPhoto1").hide();
    $("img#mainPhoto1").fadeIn("slow");
    return false;
  });
});
$(function(){
  $("img#changePhoto2").click(function(){
    var ImgSrc = $(this).attr("src");
    var ImgAlt = $(this).attr("alt");
    $("img#mainPhoto2").attr({src:ImgSrc,alt:ImgAlt});
    $("a#mainPhoto2").attr({href:ImgSrc});
    $("img#mainPhoto2").hide();
    $("img#mainPhoto2").fadeIn("slow");
    return false;
  });
});
$(function(){
  $("img#changePhoto3").click(function(){
    var ImgSrc = $(this).attr("src");
    var ImgAlt = $(this).attr("alt");
    $("img#mainPhoto3").attr({src:ImgSrc,alt:ImgAlt});
    $("a#mainPhoto3").attr({href:ImgSrc});
    $("img#mainPhoto3").hide();
    $("img#mainPhoto3").fadeIn("slow");
    return false;
  });
});